export default __webpack_public_path__ + "static/media/83.41c9a9ec.gif";